const initialState = {
  username: '',
  token: null,
  isAuthenticated: false,
  organization_id: null,
  userInfo: {},
  menuLinks: [],
  organizations: null,
  email: '',
  organizationInfo: {
    name: '',
  },
};

function user(state = initialState, action) {
  switch (action.type) {
    case 'SET_USER':
      return { ...state, ...action.payload };
    case 'SET_ORGANIZATION':
      return { ...state, organization: action.organization };
    case 'FETCH_USER':
      return { ...state, ...action.payload };
    case 'USER_INFO_SUCCESS':
      return { ...state, userInfo: action.userInfo };
    case 'USER_ORGANIZATION_SUCCESS':
      return { ...state, organizationInfo: action.organizationInfo };
    case 'USER_MENU_LINKS_SUCCESS':
      return { ...state, menuLinks: action.menuLinks };
    default:
      return state;
  }
}

export default user;
